import { combineReducers } from 'redux';
import { createReducers } from '../ducksHelpers';
import { appointmentSettings } from './appointment';
import { todayAppointmentsSettings } from './todayAppointments';
import { pendingAppointmentsSettings } from './pendingAppointments';
import { upcomingAppointmentsSettings } from './upcomingAppointments';

const settingList = [
  appointmentSettings,
  todayAppointmentsSettings,
  pendingAppointmentsSettings,
  upcomingAppointmentsSettings,
];

const dashboardReducer = combineReducers(createReducers(settingList));

export default dashboardReducer;
